export function NotFoundPage() {
  return (
    <div className="notfound">
      <div className="notfound__code">404</div>
      <p>Không tìm thấy trang này.</p>
      <a className="notfound__link" href="/">
        Về bảng giảng
      </a>
    </div>
  );
}

export default NotFoundPage;
